import React from 'react';
import ReportFrame from '../ReportFrame';

export default class AssignmentFeeRevenueByService extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const reportParams = {};
    return (
      <div className='contentwrapper bg-white'>
        <ReportFrame
          DynamicParams={['ReportType']}
          reportName='Revenue Metrics - Assignment Fee Revenue By Service'
          reportParams={reportParams}
          id='assignmentfeerevenuebyservice'
          name='assignmentfeerevenuebyservice'
          title='Assgn. Fee Revenue by Service'
        />
      </div>
    );
  }
}
